import { KeyboardDoubleArrowUp } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Chip, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { empty } from '../../Gift/assets/index';
import { variants } from '../../../variants/variants';
import { useNavigate } from 'react-router-dom';
import ReferralForm from './ReferralForm';
import introImage from '../../../assets/Job Openings.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { selectTwinWinForm, setTwinWinFormOpen } from '../gnnSlice';

const NewOpeningsCarousel = ({
  newOpenings,
  currentIndex,
  setCurrentIndex,
  isLoading,
  isError,
  isSm,
  handleCloseCarousel,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isFormOpen = useSelector(selectTwinWinForm);

  useEffect(() => {
    if (!isLoading && newOpenings) {
      setCurrentIndex(0); // Start at intro image
    }
  }, [isLoading, newOpenings]);

  useEffect(() => {
    if (currentIndex === 0) {
        dispatch(setTwinWinFormOpen(false));
    }
  },[currentIndex])


  const handleViewMore = () => {
    dispatch(setTwinWinFormOpen(true));
  };

  if (isLoading) {
    return <Card sx={{ position: 'relative', overflow: 'hidden' }}>{/* Skeleton loading UI */}</Card>;
  }

  if (isError) {
    return <Typography>Error fetching news data.</Typography>;
  }

  if (!newOpenings || newOpenings.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '92vh',
          backgroundColor: 'black',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <img style={{ width: '50%' }} src={empty} alt="pending" />
        <Typography sx={{ fontSize: variants.TINY, p: 2, color: 'lightgrey' }}>No New Openings</Typography>
      </Box>
    );
  }

  return (
    <Grid container sx={{ height: '100vh', width: '100%', backgroundColor: 'black' }}>
      {currentIndex === 0 ? (
        // Show the intro image at index 0
        <Box
          sx={{ position: 'relative', width: '100%', height: '80vh', justifyContent: 'center', alignItems: 'center' }}
        >
          <img
            src={introImage}
            alt="Intro"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              position: 'relative',
            
           
            }}
          />
        </Box>
      ) : !isFormOpen ? (
        <Box
          sx={{
            height: '80vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Card
            sx={{
              width: '100%',
              height: '60%',
              backgroundColor: 'white',
              color: 'text.secondary',
              overflowY: 'scroll',
            }}
          >
            <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography>Category</Typography>
                <Typography variant="h5" color="black">
                  {newOpenings[currentIndex - 1].job_category}
                </Typography>
              </Box>
              <Box>
                <Typography>Designation</Typography>
                <Typography variant="h6" color="black">
                  {newOpenings[currentIndex - 1].designation}
                </Typography>
              </Box>
              <Box>
                <Typography>Experience Required (in years)</Typography>
                <Typography color="black">{newOpenings[currentIndex - 1].required_experience}</Typography>
              </Box>
              <Box>
                <Typography>Job Locations</Typography>
                {newOpenings[currentIndex - 1].job_location.map((item, index) => (
                  <Chip key={index} label={item} variant="outlined" />
                ))}
              </Box>
            </CardContent>
          </Card>

          {!isSmallScreen && (
            <Grid>
              <Button variant="contained" onClick={handleViewMore}>
                Refer
              </Button>
            </Grid>
          )}

          {isSmallScreen && (
            <Grid
              sx={{
                position: 'fixed',
                bottom: '16px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'black',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                textAlign: 'center',
                padding: '8px 16px',
                borderRadius: '8px',
                display: 'flex',
              }}
            >
              <Typography sx={{ color: 'white', mr: 1 }}>
                <KeyboardDoubleArrowUp />
              </Typography>
              <Typography sx={{ color: 'white' }}>Swipe to Refer</Typography>
            </Grid>
          )}
        </Box>
      ) : (
        <Grid
          item
          xs={12}
          lg={9.5}
          container
          sx={{
            flex: 1,
            p: 1,
            pl: 0,
            display: 'grid',
            gridTemplateRows: '70px 1fr',
            height: '100%',
            width: '100%',
            margin: '0 auto',
            [theme.breakpoints.down('lg')]: {
              display: 'grid',
              p: 0,
            },
          }}
        >
          <ReferralForm
            handleNavigateBack={() => {
              dispatch(setTwinWinFormOpen(false));
            }}
            jobId={newOpenings[currentIndex - 1].id}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default NewOpeningsCarousel;
